import {html} from 'lit-html';
import {repeat} from 'lit-html/directives/repeat';
import {cache} from 'lit-html/directives/cache';
import {mark, transition} from 'lit-transition';

/**
 * Render a Product live preview
 *
 * @returns {TemplateResult}
 */
const template = (product, config) => html`
<div class="cl-po--preview"> 
    <canvas class="cl-po--canvas"></canvas>
</div>
`;


export default template;